import { render, staticRenderFns } from "./LoadFilterPresetMenu.vue?vue&type=template&id=b88516ca"
import script from "./LoadFilterPresetMenu.vue?vue&type=script&lang=ts"
export * from "./LoadFilterPresetMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports